export const translations = {
  pt: {
    nav: {
      home: "Início",
      about: "Sobre",
      services: "Serviços",
      contact: "Contacto",
      careers: "Oportunidades",
      getQuote: "Solicitar Orçamento"
    },
    hero: {
      title: "PINHACORADA",
      subtitle: "Cuidamos da Natureza",
      description: "Especialistas em Silvicultura Preventiva, Plantações, Manutenção de Espaços Verdes e Obras Públicas. Comprometidos com a sustentabilidade e proteção dos ecossistemas desde 2013.",
      servicesButton: "Serviços"
    },
    about: {
      badge: "Sobre a Pinhacorada",
      title: "Compromisso com a Natureza e a Excelência",
      description1: "A Pinhacorada é uma empresa sediada em Mortágua, especializada em Silvicultura Preventiva, Manutenção de Espaços Verdes e execução de Obras Públicas. Desde a nossa constituição em 2013, temos desenvolvido um trabalho sólido no setor florestal.",
      description2: "Assumimos um papel ativo na prevenção de incêndios e na promoção de paisagens mais resilientes, sempre com foco na sustentabilidade e na proteção dos ecossistemas.",
      location: "Sediada em Mortágua",
      founded: "Fundada em 2013",
      team: "Equipa Especializada",
      sustainability: "Foco na Sustentabilidade"
    },
    services: {
      title: "Serviços",
      description: "Oferecemos um leque completo de serviços especializados para entidades públicas e privadas, sempre com rigor técnico e responsabilidade ecológica.",
      learnMore: "Saber Mais →",
      items: [
        {
          title: "Manutenção de Espaços Verdes",
          description: "Cuidado integral de jardins e parques, garantindo beleza e saúde das plantas.",
          details: "Cuidamos da manutenção completa de jardins, parques públicos e espaços verdes corporativos, garantindo espaços verdes saudáveis, bem cuidados e visualmente apelativos ao longo de todo o ano. Prestamos um serviço profissional que inclui corte de relva, poda de árvores e arbustos, fertilização adequada e controlo eficaz de pragas e doenças. Trabalhamos com equipamento profissional e uma equipa de técnicos especializados, assegurando intervenções eficientes, seguras e adaptadas às necessidades de cada cliente, com o objetivo de valorizar os espaços verdes e reforçar uma imagem cuidada, profissional e sustentável."
        },
        {
          title: "Podas e Abates (Escalada)",
          description: "Intervenções especializadas em altura com total segurança e rigor técnico.",
          details: "Especialistas em trabalhos em altura, realizamos podas técnicas e abates de árvores de grande porte utilizando técnicas de escalada (treeclimbing). Os nossos arboristas certificados executam intervenções complexas em espaços urbanos, junto a edifícios, linhas elétricas e outras infraestruturas sensíveis. Garantimos total segurança, minimizamos impactos e cumprimos todas as normas de segurança no trabalho em altura."
        },
        {
          title: "Controlo da Vegetação Espontânea",
          description: "Gestão eficiente de infestantes para manter áreas limpas e seguras.",
          details: "O controlo da vegetação espontânea tem como objetivo reduzir ou eliminar a competição que estas plantas exercem sobre os povoamentos florestais, especialmente no acesso a recursos essenciais como a água e a luz. Em muitas situações, esta intervenção é igualmente fundamental para diminuir a carga de combustível existente no terreno e, assim, reduzir o risco de incêndio."
        },
        {
          title: "Instalação de Povoamentos",
          description: "Plantação e beneficiação de áreas florestais para produção e conservação.",
          details: "Executamos projetos completos de instalação de povoamentos florestais, desde o planeamento até à plantação. Trabalhamos com espécies autóctones e de produção (pinheiro, eucalipto, carvalho, castanheiro, entre outras). Incluímos preparação do terreno, seleção de plantas certificadas, plantação, proteção contra fauna e acompanhamento inicial. Realizamos também beneficiação de povoamentos existentes através de desbastes, podas de formação e fertilização."
        },
        {
          title: "Valorização Ambiental",
          description: "Recuperação e valorização ecológica de espaços florestais degradados.",
          details: "Desenvolvemos projetos de recuperação e valorização ambiental de áreas degradadas por incêndios, pragas ou abandono. Os nossos serviços incluem remoção de biomassa queimada, controlo de erosão, recuperação de solo, sementeiras e plantações de espécies autóctones, criação de corredores ecológicos e promoção da biodiversidade. Trabalhamos em parceria com entidades públicas e privadas para restaurar o equilíbrio dos ecossistemas florestais."
        },
        {
          title: "Infraestruturas Florestais",
          description: "Instalação e beneficiação de caminhos, aceiros e outras estruturas.",
          details: "Construímos e mantemos infraestruturas essenciais para a gestão florestal: caminhos florestais, aceiros, pontos de água, áreas de manobra para combate a incêndios e sinalização. Estas infraestruturas são fundamentais para o acesso, vigilância, exploração sustentável e proteção civil das áreas florestais, garantindo uma gestão eficaz e segura do território."
        },
        {
          title: "Gestão de Combustível",
          description: "Manutenção de faixas de gestão de combustível para prevenção de incêndios.",
          details: "Executamos a gestão de combustível em faixas de proteção conforme a legislação (Decreto-Lei n.º 124/2006 e atualizações). Realizamos limpeza de matos, remoção de biomassa, desramação de árvores e criação de descontinuidades verticais e horizontais. Trabalhamos em faixas junto a habitações, estradas, linhas elétricas e limites de propriedade. Este serviço é crucial para reduzir o risco de incêndio e proteger vidas, bens e património natural."
        }
      ]
    },
    contact: {
      title: "Tem interesse nos nossos serviços? Contacte-nos!",
      description: "Estamos disponíveis para esclarecer qualquer dúvida e fornecer um orçamento adequado às suas necessidades.",
      location: "Localização",
      locationValue: "Mortágua, Portugal",
      email: "Email",
      phone: "Telefone",
      whatsapp: "WhatsApp",
      socialMedia: "Redes Sociais",
      formTitle: "Envie-nos uma mensagem",
      formName: "Nome",
      formPhone: "Contacto",
      formEmail: "Email *",
      formPostalCode: "Código Postal",
      formService: "Serviço",
      formServicePlaceholder: "Que serviço pretende?",
      formMessage: "Mensagem *",
      formMessagePlaceholder: "Como podemos ajudar?",
      formSending: "Enviando...",
      formSubmit: "Enviar Mensagem",
      formSuccess: "Mensagem enviada com sucesso! Entraremos em contacto em breve.",
      formError: "Erro ao enviar mensagem. Tente novamente."
    },
    footer: {
      rights: "Todos os direitos reservados.",
      privacyPolicy: "Política de Privacidade",
      cookiePolicy: "Política de Cookies",
      termsOfService: "Termos de Serviço",
      complaintsBook: "Livro de Reclamações"
    },
    stats: {
      yearsExperience: "Anos de Experiência",
      projectsCompleted: "Projetos Concluídos",
      hectaresManaged: "Hectares Geridos",
      satisfiedClients: "Clientes Satisfeitos"
    },
    certifications: {
      badge: "Certificações e Seguros",
      title: "Profissionalismo e Confiança",
      description: "Operamos com todas as certificações e seguros necessários para garantir a máxima segurança e qualidade nos nossos serviços.",
      civilLiability: "Seguro de Responsabilidade Civil",
      civilLiabilityDesc: "Cobertura completa para todas as operações e projetos executados.",
      technicalLicenses: "Licenças Técnicas",
      technicalLicensesDesc: "Certificações para operações florestais e manutenção de espaços verdes.",
      environmentalCompliance: "Conformidade Ambiental",
      environmentalComplianceDesc: "Cumprimento rigoroso das normas ambientais e de segurança.",
      qualifiedTeam: "Equipa Qualificada",
      qualifiedTeamDesc: "Profissionais certificados e com formação contínua especializada.",
      legalNote: "Todas as licenças e certificações estão em conformidade com a legislação portuguesa vigente."
    },
    admin: {
      title: "Mensagens de Contacto",
      noMessages: "Nenhuma mensagem recebida ainda.",
      loading: "A carregar mensagens...",
      status: "Estado",
      statusNew: "Nova",
      statusRead: "Lida",
      statusReplied: "Respondida",
      name: "Nome",
      email: "Email",
      phone: "Telefone",
      postalCode: "Código Postal",
      service: "Serviço",
      message: "Mensagem",
      createdAt: "Data",
      markAsRead: "Marcar como lida",
      markAsReplied: "Marcar como respondida",
      delete: "Eliminar",
      confirmDelete: "Tem certeza que deseja eliminar esta mensagem?",
      filters: "Filtros",
      filterAll: "Todas",
      filterNew: "Novas",
      filterRead: "Lidas",
      filterReplied: "Respondidas",
      totalMessages: "mensagens",
      notAvailable: "N/D"
    },
    quote: {
      title: "Solicitar Orçamento",
      description: "Preencha o formulário abaixo e entraremos em contacto com uma proposta personalizada.",
      name: "Nome Completo *",
      phone: "Telefone *",
      email: "Email *",
      postalCode: "Código Postal",
      service: "Serviço Pretendido *",
      servicePlaceholder: "Que serviço necessita?",
      details: "Detalhes do Pedido *",
      detailsPlaceholder: "Descreva o trabalho que pretende realizar, área aproximada, localização...",
      sending: "Enviando...",
      submit: "Enviar Pedido de Orçamento",
      submitted: "Pedido Enviado!",
      thankYou: "Receberá o nosso orçamento em breve."
    },
    careers: {
      title: "Junte-se à Nossa Equipa",
      description: "Procuramos profissionais dedicados e apaixonados pela natureza para crescer connosco. Faça parte de uma empresa com 12 anos de excelência no setor florestal.",
      unitedTeam: "Equipa Unida",
      unitedTeamDesc: "Trabalhe com profissionais experientes num ambiente colaborativo",
      professionalGrowth: "Crescimento Profissional",
      professionalGrowthDesc: "Formação contínua e oportunidades de desenvolvimento",
      wellbeing: "Bem-estar",
      wellbeingDesc: "Condições de trabalho seguras e equipamento de qualidade",
      stability: "Estabilidade",
      stabilityDesc: "12 anos de experiência e projetos contínuos",
      openPositions: "Posições Abertas",
      forestryTechnician: "Técnico de Silvicultura",
      fullTime: "Full-time",
      location: "Mortágua",
      forestryTechnicianDesc: "Experiência em manutenção florestal e prevenção de incêndios",
      equipmentOperator: "Operador de Equipamentos",
      equipmentOperatorDesc: "Operação de máquinas florestais e equipamento especializado",
      climbingTechnician: "Técnico de Escalada",
      climbingTechnicianDesc: "Certificação em trabalhos em altura e podas especializadas",
      applyNow: "Candidate-se Agora",
      fullName: "Nome Completo *",
      email: "Email *",
      phone: "Telefone *",
      desiredPosition: "Posição Pretendida *",
      selectPosition: "Selecione...",
      otherPosition: "Outra Posição",
      messageExperience: "Mensagem / Experiência",
      messagePlaceholder: "Conte-nos sobre a sua experiência e motivação...",
      cvUpload: "Curriculum Vitae (PDF)",
      uploadCV: "Carregar CV (opcional)",
      submitApplication: "Enviar Candidatura",
      applicationSent: "Candidatura Enviada!",
      thankYou: "Obrigado pelo seu interesse. Entraremos em contacto em breve."
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      contact: "Contact",
      careers: "Opportunities",
      getQuote: "Request Quote"
    },
    hero: {
      title: "PINHACORADA",
      subtitle: "Caring for Nature",
      description: "Experts in Preventive Forestry, Plantations, Green Space Maintenance and Public Works. Committed to sustainability and ecosystem protection since 2013.",
      servicesButton: "Services"
    },
    about: {
      badge: "About Pinhacorada",
      title: "Commitment to Nature and Excellence",
      description1: "Pinhacorada is a company based in Mortágua, specialized in Preventive Forestry, Green Space Maintenance and Public Works execution. Since our establishment in 2013, we have been developing solid work in the forestry sector.",
      description2: "We take an active role in fire prevention and promoting more resilient landscapes, always focusing on sustainability and ecosystem protection.",
      location: "Based in Mortágua",
      founded: "Founded in 2013",
      team: "Specialized Team",
      sustainability: "Focus on Sustainability"
    },
    services: {
      title: "Services",
      description: "We offer a complete range of specialized services for public and private entities, always with technical rigor and ecological responsibility.",
      learnMore: "Learn More →",
      items: [
        {
          title: "Green Space Maintenance",
          description: "Comprehensive care for gardens and parks, ensuring plant beauty and health.",
          details: "We provide complete maintenance for gardens, public parks and corporate green spaces, ensuring healthy, well-maintained and visually appealing green spaces throughout the year. We deliver professional service including lawn mowing, tree and shrub pruning, proper fertilization and effective pest and disease control. We work with professional equipment and a team of specialized technicians, ensuring efficient, safe interventions adapted to each client's needs, aiming to enhance green spaces and reinforce a careful, professional and sustainable image."
        },
        {
          title: "Pruning and Felling (Climbing)",
          description: "Specialized high-altitude interventions with total safety and technical rigor.",
          details: "Experts in working at heights, we perform technical pruning and felling of large trees using climbing techniques (treeclimbing). Our certified arborists execute complex interventions in urban spaces, near buildings, power lines and other sensitive infrastructures. We guarantee total safety, minimize impacts and comply with all safety standards for working at heights."
        },
        {
          title: "Spontaneous Vegetation Control",
          description: "Efficient weed management to keep areas clean and safe.",
          details: "Spontaneous vegetation control aims to reduce or eliminate the competition these plants exert on forest stands, especially regarding access to essential resources such as water and light. In many situations, this intervention is equally fundamental to reduce the fuel load on the land and thus reduce fire risk."
        },
        {
          title: "Stand Installation",
          description: "Planting and improvement of forest areas for production and conservation.",
          details: "We execute complete forest stand installation projects, from planning to planting. We work with native and production species (pine, eucalyptus, oak, chestnut, among others). We include land preparation, selection of certified plants, planting, wildlife protection and initial monitoring. We also perform improvement of existing stands through thinning, formative pruning and fertilization."
        },
        {
          title: "Environmental Enhancement",
          description: "Recovery and ecological enhancement of degraded forest spaces.",
          details: "We develop recovery and environmental enhancement projects for areas degraded by fires, pests or abandonment. Our services include removal of burned biomass, erosion control, soil recovery, sowing and planting of native species, creation of ecological corridors and biodiversity promotion. We work in partnership with public and private entities to restore the balance of forest ecosystems."
        },
        {
          title: "Forest Infrastructure",
          description: "Installation and improvement of roads, firebreaks and other structures.",
          details: "We build and maintain essential infrastructure for forest management: forest roads, firebreaks, water points, firefighting maneuver areas and signage. These infrastructures are fundamental for access, surveillance, sustainable exploitation and civil protection of forest areas, ensuring effective and safe territory management."
        },
        {
          title: "Fuel Management",
          description: "Maintenance of fuel management strips for fire prevention.",
          details: "We execute fuel management in protection strips according to legislation (Decree-Law No. 124/2006 and updates). We perform brush clearing, biomass removal, tree pruning and creation of vertical and horizontal discontinuities. We work in strips near homes, roads, power lines and property boundaries. This service is crucial to reduce fire risk and protect lives, property and natural heritage."
        }
      ]
    },
    contact: {
      title: "Interested in our services? Contact us!",
      description: "We are available to clarify any questions and provide a quote suited to your needs.",
      location: "Location",
      locationValue: "Mortágua, Portugal",
      email: "Email",
      phone: "Phone",
      whatsapp: "WhatsApp",
      socialMedia: "Social Media",
      formTitle: "Send us a message",
      formName: "Name",
      formPhone: "Phone",
      formEmail: "Email *",
      formPostalCode: "Postal Code",
      formService: "Service",
      formServicePlaceholder: "What service do you need?",
      formMessage: "Message *",
      formMessagePlaceholder: "How can we help?",
      formSending: "Sending...",
      formSubmit: "Send Message",
      formSuccess: "Message sent successfully! We will contact you soon.",
      formError: "Error sending message. Please try again."
    },
    footer: {
      rights: "All rights reserved.",
      privacyPolicy: "Privacy Policy",
      cookiePolicy: "Cookie Policy",
      termsOfService: "Terms of Service",
      complaintsBook: "Complaints Book"
    },
    stats: {
      yearsExperience: "Years of Experience",
      projectsCompleted: "Completed Projects",
      hectaresManaged: "Hectares Managed",
      satisfiedClients: "Satisfied Clients"
    },
    certifications: {
      badge: "Certifications and Insurance",
      title: "Professionalism and Trust",
      description: "We operate with all necessary certifications and insurance to guarantee maximum safety and quality in our services.",
      civilLiability: "Civil Liability Insurance",
      civilLiabilityDesc: "Complete coverage for all operations and projects executed.",
      technicalLicenses: "Technical Licenses",
      technicalLicensesDesc: "Certifications for forestry operations and green space maintenance.",
      environmentalCompliance: "Environmental Compliance",
      environmentalComplianceDesc: "Strict compliance with environmental and safety standards.",
      qualifiedTeam: "Qualified Team",
      qualifiedTeamDesc: "Certified professionals with continuous specialized training.",
      legalNote: "All licenses and certifications comply with current Portuguese legislation."
    },
    admin: {
      title: "Contact Messages",
      noMessages: "No messages received yet.",
      loading: "Loading messages...",
      status: "Status",
      statusNew: "New",
      statusRead: "Read",
      statusReplied: "Replied",
      name: "Name",
      email: "Email",
      phone: "Phone",
      postalCode: "Postal Code",
      service: "Service",
      message: "Message",
      createdAt: "Date",
      markAsRead: "Mark as read",
      markAsReplied: "Mark as replied",
      delete: "Delete",
      confirmDelete: "Are you sure you want to delete this message?",
      filters: "Filters",
      filterAll: "All",
      filterNew: "New",
      filterRead: "Read",
      filterReplied: "Replied",
      totalMessages: "messages",
      notAvailable: "N/A"
    },
    quote: {
      title: "Request Quote",
      description: "Fill out the form below and we will contact you with a personalized proposal.",
      name: "Full Name *",
      phone: "Phone *",
      email: "Email *",
      postalCode: "Postal Code",
      service: "Desired Service *",
      servicePlaceholder: "What service do you need?",
      details: "Request Details *",
      detailsPlaceholder: "Describe the work you want done, approximate area, location...",
      sending: "Sending...",
      submit: "Send Quote Request",
      submitted: "Request Sent!",
      thankYou: "You will receive our quote soon."
    },
    careers: {
      title: "Join Our Team",
      description: "We are looking for dedicated professionals passionate about nature to grow with us. Be part of a company with 12 years of excellence in the forestry sector.",
      unitedTeam: "United Team",
      unitedTeamDesc: "Work with experienced professionals in a collaborative environment",
      professionalGrowth: "Professional Growth",
      professionalGrowthDesc: "Continuous training and development opportunities",
      wellbeing: "Wellbeing",
      wellbeingDesc: "Safe working conditions and quality equipment",
      stability: "Stability",
      stabilityDesc: "12 years of experience and continuous projects",
      openPositions: "Open Positions",
      forestryTechnician: "Forestry Technician",
      fullTime: "Full-time",
      location: "Mortágua",
      forestryTechnicianDesc: "Experience in forest maintenance and fire prevention",
      equipmentOperator: "Equipment Operator",
      equipmentOperatorDesc: "Operation of forestry machinery and specialized equipment",
      climbingTechnician: "Climbing Technician",
      climbingTechnicianDesc: "Certification in working at heights and specialized pruning",
      applyNow: "Apply Now",
      fullName: "Full Name *",
      email: "Email *",
      phone: "Phone *",
      desiredPosition: "Desired Position *",
      selectPosition: "Select...",
      otherPosition: "Other Position",
      messageExperience: "Message / Experience",
      messagePlaceholder: "Tell us about your experience and motivation...",
      cvUpload: "Curriculum Vitae (PDF)",
      uploadCV: "Upload CV (optional)",
      submitApplication: "Submit Application",
      applicationSent: "Application Sent!",
      thankYou: "Thank you for your interest. We will be in touch soon."
    }
  }
};
